// extracted by mini-css-extract-plugin
module.exports = {"container":"notifications_container__2jCBp"};